import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { WisetackSettings } from '@/types/settings';

export function useWisetackSettings(options?: { enabled?: boolean }) {
  return useApiQuery<WisetackSettings>({
    queryKey: settingsKeys.wisetackSettings(),
    queryFn: () => apiGet<WisetackSettings>(operationsClient, settingsEndpoints.wisetackSettings()),
    enabled: options?.enabled ?? true,
    showErrorToast: false,
  });
}
